import { render, staticRenderFns } from "./headline.vue?vue&type=template&id=c0ea2764&scoped=true"
import script from "./headline.vue?vue&type=script&lang=js"
export * from "./headline.vue?vue&type=script&lang=js"
import style0 from "./headline.vue?vue&type=style&index=0&id=c0ea2764&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ea2764",
  null
  
)

export default component.exports